// src/components/institution/sections/AcademicProgramsSection.jsx
import React from 'react';
import { BookOpen, Clock, Users, Award, ChevronRight } from 'lucide-react';

export const AcademicProgramsSection = ({ data, settings, styling, onProgramClick }) => {
  // Mock programs data
  const programs = settings?.programs || [
    {
      id: '1',
      name: 'Computer Science',
      department: 'Technology',
      level: 'Undergraduate',
      duration: '4 years',
      description: 'Comprehensive program covering software development, algorithms, and computer systems.',
      enrollment: 150,
      status: 'active'
    },
    {
      id: '2',
      name: 'Business Administration',
      department: 'Business',
      level: 'Graduate',
      duration: '2 years',
      description: 'Advanced business management and leadership program.',
      enrollment: 80,
      status: 'active'
    },
    {
      id: '3',
      name: 'Digital Marketing',
      department: 'Marketing',
      level: 'Certificate',
      duration: '6 months',
      description: 'Practical digital marketing skills and strategies.',
      enrollment: 45,
      status: 'active'
    }
  ];

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: styling?.primaryColor || '#1e40af' }}
          >
            Academic Programs
          </h2>
          <div className="w-24 h-1 mx-auto mb-8" style={{ backgroundColor: styling?.primaryColor }} />
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our diverse range of programs designed to prepare you for success.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program) => (
            <div 
              key={program.id}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-shadow cursor-pointer"
              onClick={() => onProgramClick && onProgramClick(program)}
            >
              <div className="flex items-center gap-3 mb-4">
                <div 
                  className="p-3 rounded-lg"
                  style={{ backgroundColor: `${styling?.primaryColor || '#1e40af'}20` }}
                >
                  <BookOpen 
                    className="h-6 w-6" 
                    style={{ color: styling?.primaryColor || '#1e40af' }}
                  />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">{program.name}</h3>
                  <p className="text-sm text-gray-500">{program.department}</p>
                </div>
              </div>

              <p className="text-gray-600 mb-6 line-clamp-3">
                {program.description}
              </p>

              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Award className="h-4 w-4" />
                  <span>{program.level}</span>
                </div>
                
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Clock className="h-4 w-4" />
                  <span>{program.duration}</span>
                </div>

                {program.enrollment && (
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Users className="h-4 w-4" />
                    <span>{program.enrollment} students enrolled</span>
                  </div>
                )}
              </div>

              <button
                className="w-full text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
                style={{ backgroundColor: styling?.primaryColor || '#1e40af' }}
              >
                Learn More
                <ChevronRight className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};